export function formatSnapshotDistance(km: number | null | undefined): string {
  if (km == null || km <= 0) return '-';
  return `${Math.round(km)} km`;
}

export function formatSnapshotDuration(minutes: number | null | undefined): string {
  if (minutes == null || minutes <= 0) return '-';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h > 0 && m > 0) return `${h}h ${m}m`;
  if (h > 0) return `${h}h`;
  return `${m}m`;
}

export function formatSnapshotStops(count: number | null | undefined): string {
  if (count == null || count <= 0) return '- Stops';
  return count === 1 ? '1 Stop' : `${count} Stops`;
}
